import {createSelector, type Selector} from "@reduxjs/toolkit";

import {GameUtils} from "@atg-tillsammans/game-utils";

import type {GlobalGameState} from "./gameTypes";
import type {Game, GameSummary} from "@atg-tillsammans/game-types";

export const getGameById: (gameId: string) => Selector<GlobalGameState, Game | null> = (
    gameId: string,
) =>
    createSelector(
        (state: GlobalGameState) => state.game.horse.games,
        (state: GlobalGameState) => state.game.sport.games,
        (horseGames, sportGames): Game | null =>
            horseGames[gameId] || sportGames[gameId] || null,
    );

export const getGameSummaryById: (
    gameId: string,
) => Selector<GlobalGameState, GameSummary | null> = (gameId: string) =>
    createSelector(getGameById(gameId), (game): GameSummary | null =>
        game ? GameUtils.mapGameToGameSummary(game) : null,
    );
